import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { Popper } from 'react-popper';
import { getForcedGlobalClassnamesForContext } from '../Context/helpers';
import TooltipContent from './_partials/TooltipContent';
import ErrorBoundary from '../ErrorBoundary';
import s from './Tooltip.scss';
var instanceCount = 0;
var TooltipPopper = /** @class */ (function (_super) {
    __extends(TooltipPopper, _super);
    function TooltipPopper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.portalName = "popper-root-" + instanceCount++;
        _this.renderPopper = function () {
            var _a = _this.props, className = _a.className, forceTheme = _a.forceTheme, isOpen = _a.isOpen, children = _a.children, placement = _a.placement, modifiers = _a.modifiers, positionFixed = _a.positionFixed, eventsEnabled = _a.eventsEnabled, referenceElement = _a.referenceElement, usePortal = _a.usePortal, renderTooltipContent = _a.renderTooltipContent, disablePlacementModifier = _a.disablePlacementModifier, innerRef = _a.innerRef, tooltipProps = __rest(_a, ["className", "forceTheme", "isOpen", "children", "placement", "modifiers", "positionFixed", "eventsEnabled", "referenceElement", "usePortal", "renderTooltipContent", "disablePlacementModifier", "innerRef"]);
            var props = {
                placement: _this.getPlacement(),
                eventsEnabled: eventsEnabled,
                positionFixed: positionFixed,
                modifiers: __assign({ overridePlacement: {
                        /* This modifier will force the tooltip to not be centered when it reaches
                           the max width, as per designers request. By default it sets the `start`
                           placement variant when that is the case, but if the tooltip doesn't fit
                           the built-in `flip` modifier will kick in and position it accordingly. */
                        enabled: !disablePlacementModifier,
                        order: 50,
                        fn: function (data) {
                            var width = data.offsets.popper.width;
                            var maxWidth = _this.props.disablePlacementModifier
                                ? Number.POSITIVE_INFINITY
                                : parseInt(s['wrapper_max_width']);
                            var _a = data.placement.split('-'), basePlacement = _a[0], variantPlacement = _a[1];
                            var finalPlacement = width >= maxWidth && !variantPlacement
                                ? basePlacement + "-start"
                                : data.placement;
                            return __assign(__assign({}, data), { placement: finalPlacement });
                        },
                    } }, modifiers),
            };
            if (referenceElement) {
                props.referenceElement = referenceElement;
            }
            return (React.createElement(Popper, __assign({}, props), function (_a) {
                var rootRef = _a.ref, scheduleUpdate = _a.scheduleUpdate, popperProps = __rest(_a, ["ref", "scheduleUpdate"]);
                return (React.createElement(TooltipContent, __assign({ className: classnames(className, forceTheme &&
                        getForcedGlobalClassnamesForContext({ theme: forceTheme })), rootRef: function (node) {
                        rootRef(node);
                        innerRef && innerRef(node);
                    }, scheduleUpdate: scheduleUpdate, onResize: scheduleUpdate }, popperProps, tooltipProps),
                    React.createElement(ErrorBoundary, null, renderTooltipContent
                        ? renderTooltipContent({
                            scheduleUpdate: scheduleUpdate,
                            placement: popperProps.placement,
                        })
                        : children)));
            }));
        };
        return _this;
    }
    TooltipPopper.prototype.componentWillUnmount = function () {
        var root = this.getPortalContainer();
        root.remove();
    };
    TooltipPopper.prototype.render = function () {
        var _a = this.props, _b = _a.isOpen, isOpen = _b === void 0 ? true : _b, usePortal = _a.usePortal;
        if (typeof document === 'undefined' || !isOpen) {
            return null;
        }
        if (usePortal) {
            return ReactDOM.createPortal(this.renderPopper(), this.getPortalContainer());
        }
        return this.renderPopper();
    };
    TooltipPopper.prototype.getPortalContainer = function () {
        var root = document.getElementById(this.portalName);
        if (!root) {
            root = document.createElement('div');
            root.id = this.portalName;
            root.className = s['portal'];
            document.body.appendChild(root);
        }
        return root;
    };
    TooltipPopper.prototype.getPlacement = function () {
        var _a = this.props.placement, placement = _a === void 0 ? 'top' : _a;
        if (placement === 'topright') {
            // eslint-disable-next-line no-console
            console.warn('Tooltip placement topright is deprecated, please update to top-end');
            return 'top-end';
        }
        return placement;
    };
    return TooltipPopper;
}(React.Component));
export { TooltipPopper };
export default TooltipPopper;
//# sourceMappingURL=TooltipPopper.js.map